import React from "react";

import Modals from "../popupModal/modal";

const LoginModal = ({ isOpen, onSuccess, closeModal }) => {
  return (
    <Modals
      isOpen={isOpen}
      onRequestClose={() => closeModal}
      title="Log In Confirmation"
      btnDark={{
        label: "Confirm",
        onclick: () => {
          onSuccess();
          closeModal();
        },
      }}
      btnOutline={{
        label: "Cancel",
        onclick: () => {
          closeModal();
        },
      }}
    >
      <React.Fragment>
        <button
          onClick={closeModal}
          className="close modalCloseBtn"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <p className="mx-auto text-center denyAppointmentText">
        If this user is already logged in to other device and you continue here the other session would be terminated. 
         You may loose your appointment session data
        </p>
      </React.Fragment>
    </Modals>
  );
};

export default LoginModal;
